import useReveal from '../../hooks/useReveal';
import './Reveal.css';

/**
 * Fades and lifts its content into place the first time it scrolls into view.
 *
 * By default the wrapper itself animates, which suits a block that should
 * arrive as one piece. Pass `group` when the wrapper contains a row or grid:
 * the wrapper then holds its position and every `data-reveal-item` inside it
 * arrives in sequence. Give those items a `--reveal-index` to order them.
 */
const Reveal = ({
  as: Tag = 'div',
  group = false,
  delay = 0,
  className = '',
  style,
  children,
  ...rest
}) => {
  const [ref, isRevealed] = useReveal();

  const classNames = ['reveal'];
  if (group) {
    classNames.push('reveal--group');
  }
  if (isRevealed) {
    classNames.push('reveal--visible');
  }
  if (className) {
    classNames.push(className);
  }

  return (
    <Tag
      ref={ref}
      className={classNames.join(' ')}
      style={delay ? { '--reveal-delay': `${delay}ms`, ...style } : style}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
